/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Step marks read as accent when active/completed, hairline-grey before — they used to be
// white dots that only worked on the retired blue gradient.
import colors from "assets/theme-dark/base/colors";
import pxToRem from "assets/theme-dark/functions/pxToRem";

const { accent, borderColor } = colors;

const stepIcon = {
  styleOverrides: {
    root: {
      background: borderColor.strong,
      fill: borderColor.strong,
      stroke: borderColor.strong,
      strokeWidth: pxToRem(10),
      width: pxToRem(13),
      height: pxToRem(13),
      borderRadius: "50%",
      zIndex: 99,
      transition: "all 200ms linear",

      "&.Mui-active": {
        background: accent.main,
        fill: accent.main,
        stroke: accent.main,
        borderColor: accent.main,
      },

      "&.Mui-completed": {
        background: accent.main,
        fill: accent.main,
        stroke: accent.main,
        borderColor: accent.main,
      },
    },
  },
};

export default stepIcon;
